export default __webpack_public_path__ + "static/media/icon_warning.b0cc41af.svg";